import React from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { DataProvider } from './context/DataContext';
import { AuthProvider } from './context/AuthContext';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import { Places, Hotels, Food, Vehicles, Packages, About, Contact, CancellationPolicy, TermsConditions,InternationalPackages } from './pages/OtherPages';
// import Admin from './pages/admin/Admin';
import './styles/global.css';
import './pages/Home.css';
import './pages/Hotels.css';
import './pages/admin/Admin.css';
import './pages/admin/AdminLogin.css';

function ScrollToTop() {
  const { pathname } = useLocation();
  React.useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function Layout({ children, noFooter }) {
  return (
    <>
      <Navbar />
      <main>{children}</main>
      {!noFooter && <Footer />}
    </>
  );
}

export default function App() {
  return (
    <DataProvider>
      <AuthProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<Layout><Home /></Layout>} />
            <Route path="/places" element={<Layout><Places /></Layout>} />
            <Route path="/packages" element={<Layout><Packages /></Layout>} />
            <Route path="/hotels" element={<Layout><Hotels /></Layout>} />
            <Route path="/food" element={<Layout><Food /></Layout>} />
            <Route path="/vehicles" element={<Layout><Vehicles /></Layout>} />
            <Route path="/about" element={<Layout><About /></Layout>} />
            <Route path="/contact" element={<Layout><Contact /></Layout>} />
            <Route path="/cancellation-policy" element={<Layout><CancellationPolicy /></Layout>} />
            <Route path="/terms" element={<Layout><TermsConditions /></Layout>} />
            <Route path="/international" element={<Layout><InternationalPackages /></Layout>} />
            {/* <Route path="/admin" element={<Layout noFooter><Admin /></Layout>} /> */}
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </DataProvider>
  );
}
